import { render, staticRenderFns } from "./create_module.vue?vue&type=template&id=5aa88a77"
import script from "./create_module.vue?vue&type=script&lang=js"
export * from "./create_module.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports